import React from 'react';
import { FORM_ID, MODAL_HEADER_ID } from './ManageExcessCashModal.meta';
import { Modal } from '../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../CommonComponents/OPL/Modal/ModalHeader';
import { ModalFooter } from '../CommonComponents/OPL/Modal/ModalFooter';
import { ModalBody } from '../CommonComponents/OPL/Modal/ModalBody';
import { Button } from '../CommonComponents/OPL/Button/Button';
import { useManageExcessCashQuery } from './api/useManageExcessCashQuery';
import { ModalCloseButton } from '../CommonComponents/OPL/Modal/ModalCloseButton';
import { ManageExcessCashModalLoading } from './ManageExcessCashModal.loading';
import { ExcessCashModalForm } from './components/ExcessCashModalForm';
import { Alert } from '../CommonComponents/OPL/Alert/Alert';
import { useManageExcessCashMutation } from './api/useManageExcessCashMutation';

interface Props {
  showGoalEarmark?: boolean;
  onClose(): void;
}

export const ManageExcessCashModal: React.FC<Props> = ({ showGoalEarmark = false, onClose }) => {
  const { data, isLoading, isFetching, isError } = useManageExcessCashQuery();

  const {
    mutateAsync: saveExcessCash,
    isLoading: isSavingCashAllocation,
    error: saveCashAllocationError,
  } = useManageExcessCashMutation();

  if (isLoading || isFetching) {
    return <ManageExcessCashModalLoading />;
  }

  if (!data || isError) {
    return null;
  }

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      aria={{ labelledby: MODAL_HEADER_ID }}
      size="large"
      shouldCloseOnOverlayClick={false}
    >
      <ModalHeader as="h2" id={MODAL_HEADER_ID}>
        Manage Saved Cash Allocation
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody css="min-height: 40vh">
        {saveCashAllocationError && (
          <Alert variant="error" message={saveCashAllocationError.message} />
        )}
        <ExcessCashModalForm
          saveExcessCash={saveExcessCash}
          data={data}
          showGoalEarmark={showGoalEarmark}
          onClose={onClose}
        />
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button
          variant="primary"
          type="submit"
          ml="12"
          form={FORM_ID}
          isLoading={isSavingCashAllocation}
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};
